import React from 'react';
import { motion } from 'framer-motion';
import { goToCheckout, PRICE_LABEL } from '../lib/checkout';
export function FooterCta() {
  return <section className="py-16 px-4 bg-primary text-white" data-id="element-72" data-mp="1vx340q3jfpr6">
      <div className="max-w-4xl mx-auto text-center" data-id="element-73" data-mp="1i79f67s195hg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-74" data-mp="1i4dguic9wesh">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-75" data-mp="1d7n15w4drl7l">
            🏋️ STRETCHING 360 — El sistema de planificación N°1 para
            instructores de stretching.
          </h2>

          <p className="text-xl md:text-2xl mb-12 text-white/90 italic" data-id="element-76" data-mp="1466rjqle3n4f">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>

          <div className="mb-8" data-id="element-77" data-mp="2yl9b77nrcazf">
            <p className="text-2xl font-bold mb-6" data-id="element-78" data-mp="2yjenjll3q4rn">
              ¿Sigues improvisando el lunes por la mañana?
            </p>
            <p className="text-xl mb-2" data-id="element-79" data-mp="18zxn5ch64mc6">👇</p>
          </div>

          <div className="mb-8" data-id="element-80" data-mp="14znji6gum80h">
            <div className="bg-white/10 rounded-lg p-6 border border-white/20 max-w-md mx-auto" data-id="element-81" data-mp="14ycey4fkww8b">
              <p className="text-lg font-semibold mb-2" data-id="element-82" data-mp="1itxznzes4tux">
                📘 MEGAPACK STRETCHING 360 → {PRICE_LABEL}
              </p>
              <p className="text-sm text-white/80" data-id="element-83" data-mp="q2wkvzf010bx">12 Tomos + 6 Bonus</p>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={goToCheckout} className="bg-accent text-white px-12 py-5 rounded-full font-bold text-xl mb-8 hover:bg-accent-dark transition-colors shadow-2xl" data-id="element-84" data-mp="m22r4pevkrb4">
            SÍ, QUIERO MI STRETCHING 360 →
          </motion.button>

          <div className="text-sm text-white/80 space-y-1 mb-12" data-id="element-85" data-mp="26gcxfe5fd9dr">
            <p data-id="element-86" data-mp="2eidss8liqbas">Pago seguro · Acceso en 5 min</p>
            <p data-id="element-87" data-mp="2ehkiixncp3nw">Garantía 7 días sin preguntas</p>
            <p data-id="element-88" data-mp="2ijfjg11ddf15">Tarjeta · Débito · Transferencia</p>
          </div>

          <div className="border-t border-white/20 pt-8" data-id="element-89" data-mp="2ihw5ih36rg2j">
            <p className="text-2xl font-bold mb-4" data-id="element-90" data-mp="2niim5etvn95y">🏋️ STRETCHING 360™</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm mb-4" data-id="element-91" data-mp="2shmw47omlaxc">
              <a href="mailto:contacto@stretching360.com" className="hover:text-highlight transition-colors" data-id="element-92" data-mp="2sfiuxxi42q0r">
                📧 contacto@stretching360.com
              </a>
              <span data-id="element-93" data-mp="24skhl8pafy72">|</span>
              <a href="#" className="hover:text-highlight transition-colors" data-id="element-94" data-mp="24r9d16o0qmew">
                📲 @stretching360
              </a>
              <span data-id="element-95" data-mp="29kc0cx27czmn">|</span>
              <a href="#" className="hover:text-highlight transition-colors" data-id="element-96" data-mp="1c3mzp6ozo3eu">
                🌐 www.stretching360.com
              </a>
            </div>
            <p className="text-xs text-white/60" data-id="element-97" data-mp="1h15br5yayyr2">
              © STRETCHING 360™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-xs text-white/60 mt-2" data-id="element-98" data-mp="19gunex5nttf0">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}